import { APP_PREFIX_PATH } from "configs/AppConfig";
import { USER_ROLES } from "configs/UserRoleConfig";

const dashBoardNavTree = [
	{
		key: "Dashboard",
		path: `${APP_PREFIX_PATH}/Dashboard`,
		title: "sidenav.dashboard.title",
		icon: "",
		permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
		breadcrumb: true,
		submenu: [
			{
				key: "Zodiac",
				path: `${APP_PREFIX_PATH}/list`,
				title: "Zodiac Systems",
				icon: "Lock-Group1",
				size: 25,
				permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
				breadcrumb: false,
				submenu: [],
			},
			{
				key: "Users",
				path: `${APP_PREFIX_PATH}/users/list`,
				title: "Users",
				icon: "User-Groups1",
				size: 25,
				permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
				breadcrumb: false,
				submenu: [],
			},
			{
				key: "Admin",
				path: ``,
				title: "Administrators",
				icon: "Settings",
				size: 20,
				permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
				breadcrumb: false,
				submenu: [
					{
						key: "Admin-role",
						path: `${APP_PREFIX_PATH}/roles`,
						title: "Roles",
						icon: "",
						size: 25,
						permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
						breadcrumb: false,
						submenu: [],
					},
					{
						key: "Admin-list",
						path: `${APP_PREFIX_PATH}/admin/`,
						title: "List",
						icon: "",
						size: 25,
						permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
						breadcrumb: false,
						submenu: [],
					},
				],
			},
		],
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
